import React from 'react';
import ListPageLayout from '@layouts/ListPageLayout';
import BtnAddNew from '@components/BtnAddNew/BtnAddNew';
import {withRouter} from 'react-router'

import MyRakeBackFilterForm from './MyRakeBackFilterForm';
import MyRakeBackListTable from './MyRakeBackListTable';
import UserBetRecordListTable from '@ViewsDashboard/User/UserList/UserBetRecord/UserBetRecordListTable';

import update_to_agent_store from '@store/Agent/UpdateToAgentStore';
import my_rake_back_store, { pagination_store, filter_store } from '@store/Statistic/MyRakeBack/MyRakeBackStore';

import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';

@withRouter
class MyRakeBackList extends React.PureComponent {

  constructor(props)
  {
    super();

    let state = props.location.state;
    this.updateDatas(state);
  }
  componentWillReceiveProps(props) {
    let state = props.location.state;

    this.updateDatas(state);
  }
  updateDatas(state) {

    breadcrumb_store.resetByName('投注返佣记录');

    if (state == undefined)
    {

      filter_store.resetAttr()
    }
    else
    {

      filter_store.setAttr(state)
    }
  }

  showAddNewAgentModal = () => {
    update_to_agent_store.openModal();
  }

  render() {
    return (
      <ListPageLayout
        isCustomHeader
        hideBreadcrumb
        header={
          <MyRakeBackFilterForm />
        }
        list={
          <MyRakeBackListTable />
        }
        modal={
          <div>
            {/*<UserBetRecordModal />*/}
          </div>
        }
      />
    );
  }
}

export default MyRakeBackList;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/MyRakeBack/MyRakeBackList.jsx